import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_versioning_video_download_modal = _resolveComponent("versioning-video-download-modal");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("a", {
    onClick: _cache[0] || (_cache[0] = $event => _ctx.toggleDownloadModal())
  }, [...(_cache[2] || (_cache[2] = [_createElementVNode("span", {
    class: "mdi mdi-download small light2"
  }, null, -1)]))]), _ctx.displayModal ? (_openBlock(), _createBlock(_component_versioning_video_download_modal, {
    key: 0,
    visible: true,
    "log-id": _ctx.logId,
    start: _ctx.start,
    fileName: _ctx.fileName,
    onOnDialogClose: _cache[1] || (_cache[1] = $event => _ctx.closeModal())
  }, null, 8, ["log-id", "start", "fileName"])) : _createCommentVNode("", true)], 64);
}